<script setup lang="ts">
import { PartType, PartTypesShortNames, partIcons } from '@/types/rc/miners/PartType'
import { Icon } from '@iconify/vue'

const emit = defineEmits(['change'])

const selectedPartType = defineModel<PartType>()

const availablePartTypes = [PartType.PowerSupply, PartType.ControlBoard, PartType.Hashboard, PartType.Fan]

const onClick = (type: PartType) => {
  if (type === selectedPartType.value) return
  emit('change', type)
  selectedPartType.value = type
}
</script>

<template>
  <el-button-group>
    <el-button
      v-for="type in availablePartTypes"
      :key="type"
      :class="{ selected: selectedPartType == type }"
      @click="onClick(type)"
    >
      <Icon :icon="partIcons[type]" /> {{ PartTypesShortNames[type] }}
    </el-button>
  </el-button-group>
</template>

<style lang="scss">
.el-button-group {
  display: flex;
  width: 100%;

  .el-button {
    flex-grow: 1;

    .iconify {
      margin-right: var(--spacing-spacing-xs);
    }

    &.selected {
      border-color: var(--text-brand);
      color: var(--text-brand);
      background-color: var(--fill-ep-selected);

      svg {
        color: var(--text-brand);
      }
    }
  }
}
</style>
